import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { BsDatabaseCheck, BsPeople } from "react-icons/bs";
import { PiBriefcaseBold, PiFactoryDuotone } from "react-icons/pi";

const AnimatedNumber = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (!end || hasAnimated.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          let start = 0;
          const increment = end / (duration / 16);

          const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
              setCount(end);
              clearInterval(timer);
            } else {
              setCount(Math.floor(start));
            }
          }, 16);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [end, duration]);

  return <span ref={ref}>{count}</span>;
};

const Counter = () => {
  const [statData, setStatData] = useState(null);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  console.log("Counter mounted, API URL is:", process.env.REACT_APP_API_URL);
  const fetchStats = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}stat/all`);
      console.log("stat/all response:", res.data);
      setStatData(res.data?.data);
    } catch (err) {
      console.error("Failed to fetch stats:", err);
    } finally {
      setLoading(false);
    }
  };
  fetchStats();
}, []);

  const counters = [
    { title: "ejob users", value: statData?.jobSeeker?.length, Icon: BsPeople },
    { title: "Companies", value: statData?.companies?.length, Icon: PiFactoryDuotone },
    { title: "Applications", value: statData?.applications?.length, Icon: BsDatabaseCheck },
    { title: "Jobs", value: statData?.jobs?.length, Icon: PiBriefcaseBold },
  ];

  return (
    <div>
      <section className="bg-white py-2 sm:py-2 px-5 sm:px-20 ">
        <p className="text-center text-gray-700 mb-8 mt-10 sm:mt-10">
          Job allowance offers you the sum of ₦5000 - ₦10000 monthly to cover
          your transportation allowance to potential employers for interview and
          will be deducted once you get a job.
        </p>

        <div className="flex flex-row justify-center gap-1 sm:gap-16   sm:flex-wrap font-semibold text-gray-800">
          {counters.map(({ title, value, Icon }) => (
            <div
              key={title}
              className="bg-orange-100 px-12 w-16 sm:px-16 sm:w-56 h-12 sm:h-auto transition-all duration-500 py-8 hover:bg-orange-600 hover:scale-105 hover:text-white text-orange-500 flex items-center justify-center flex-col m-0"
            >
              <Icon className="w-5 h-5" />
              <span className="text-1xl block font-semibold">
                {loading ? "..." : <AnimatedNumber end={parseInt(value, 10) || 0} />}
              </span>
              <span className="text-sm block font-semibold">{title}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Counter;